<div class="categories-page">
  <div class="container">
    <!-- Header -->
    <div class="page-header">
      <h1>Categorie</h1>
      <p class="page-description">Esplora i nostri episodi divisi per categorie</p>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
      <div class="spinner"></div>
      <p>Caricamento categorie...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <p>{{ error }}</p>
      <button (click)="loadCategories()" class="retry-button">Riprova</button>
    </div>

    <!-- Categories Grid -->
    <div *ngIf="!loading && !error && categories.length > 0" class="categories-grid">
      <div *ngFor="let category of categories" class="category-card">
        <a [routerLink]="['/categoria', category.slug]" class="category-link">
          <div class="category-icon" [style.background-color]="category.color || '#6366f1'">
            <span *ngIf="category.icon">{{ category.icon }}</span>
            <span *ngIf="!category.icon">📚</span>
          </div>
          <div class="category-content">
            <h3>{{ category.name }}</h3>
            <p *ngIf="category.description" class="category-description">
              {{ category.description }}
            </p>
            <div class="category-meta">
              <span class="episode-count">
                {{ category.episodeCount || 0 }} 
                {{ (category.episodeCount || 0) === 1 ? 'episodio' : 'episodi' }}
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !error && categories.length === 0" class="empty-state">
      <p>Nessuna categoria disponibile al momento.</p>
    </div>
  </div>
</div>
